import { TableColumn } from "react-data-table-component";
import { TopicCategory } from "../../../../core/topicCategory/entities/TopicCategory";

const topicCategoryTableConfig: TableColumn<TopicCategory>[] = [
  {
    name: "topicCategory.field.name",
    selector: (row: TopicCategory) => row.name,
  },
];

export default topicCategoryTableConfig;
